<template>
<div id="container">
			<div class="location">
				<ul>
					<li class="home">홈</li>
					<li>계약 약정서</li>
				</ul>
			</div>

			<div class="pageTit">
				<div class="conWrap">
					<h2>적하보험 인터넷 계약 약정서</h2>
				</div>
			</div>

			<div class="contents">
				<div class="conWrap">
					<div class="conStyle1">
						<p class="tit mgt0">가입전 유의사항</p>
						<p class="txt">당사[이하 보험계약자라 칭한다]와 메리츠화재해상보험주식보험사[이하 보험사라 칭한다.]는 보험계약자가<br> 직접수출/입하는 화물 또는 보험계약자의 화물에 관해 무역업무를 대행하는 대행 업체가 수출/입하는 화물에 대하여<br>  인터넷 적하보험계약을 체결함에 있어서 다음의 사항을 약정한다.</p>
					</div>

					<div class="termsView">
						<p class="tit">[제 1 조] 적용의 범위</p>
						<p class="txt">본 약정은 "보험사"가 지정한 인터넷사이트를 통하여 적하보험의 청약, 증권출력, 보험료납부 등의 서비스 이용에 적용된다.</p>

						<p class="tit">[제 2 조] 약정의 체결</p>
						<p class="txt">"보험계약자"가 적하보험 인터넷 서비스를 이용하고자 할 경우 "보험계약자"는 아래의 서류를 작성하여, "보험사"에게 송부하고,<br> "보험사"는 이를 검토 후 E-mail 또는 유선을 통하여 "보험계약자" 에게 이용자 ID를 제공함으로서 약정이 체결된다.</p>
						<ol>
							<li>적하보험 인터넷 서비스 이용 약정서 및 서비스 이용 신청서</li>
							<li>보험계약자의 사업자등록증</li>
						</ol>

						<p class="tit">[제 3 조] 서비스 이용 조건의 동의</p>
						<p class="txt">인터넷 사이트를 통하여 "보험계약자"가 직접 보험계약을 청약 입력하거나, 보험증권을 스스로출력하는 서비스를 이용하는 경우, 다음 각 호의 사항에 대하여 동의한 것으로 본다.</p>
						<ol>
							<li>이용자 ID와 비밀번호를 거쳐 로그인된 상태에서 청약사항을 입력하는 행위는 적극적인 보험청약의 의사를 표현한 것으로 보며, 잘못된 청약 내용의 입력으로 발생하는 손해에 대하여 "보험사"는 책임을 지지 아니한다.</li>
							<li>보험업법 제95조의 2에서 정하는 상품에 대한 설명을 최초 1회 "보험사"가 실시하고 이를 보험계약자가 확인한 경우, 계약자는 이후 발생하는 동일 상품에 대해서도 설명을 받고 확인한 것으로 본다.</li>
							<li>"보험계약자"는 보험업법 제96조 ②항 3호에서 규정한 통신수단을 이용한 보험계약의 변경 및 해지의 동의 유무를 최초 적하보험 서비스 이용 신청서에 명기하여야 하며, 별도의 변경의사를 표시하지 않는 경우 모든 계약에 동일하게 적용한다.</li>
							<li>"보험계약자"는 직접 청약 입력하였든, "보험사"에서 입력하였든 보험계약에 대하여 청약한 내용과 보험증권의 내용이 일치하는지를 확인하여야 하며, "보험계약자"의 잘못된 청약이나 확인 부주의로 인한 증권 기재내용의 오기에 대해서는 "보험사"는 책임을 지지 아니한다.</li>
						</ol>

						<p class="tit">[제 4 조] 서비스이용 약정기간</p>
						<ol>
							<li>"보험사"가 서비스 이용 신청을 승인한 날로부터 1년이며, 별도의 의사표시가 없는 한 1년간 자동 연장된다.</li>
							<li>단, "보험사"의 경영정책변화 또는 관계 법규정 변경에 따라 서비스가 중단되는 경우, 약정기간도 자동 종료된다.</li>
							<li>"보험계약자"가 보험료 납입의 지체, 인터넷 서비스 또는 증권용지의 오용, 기타 법령 및 약정서의 사용을 위반하는 행위를 하거나 그럴 우려가 있는 경우, "보험사"는 서비스를 중단할 수 있다.</li>
						</ol>


						<p class="tit">[제 5 조] 통신장애로 인한 업무 장애</p>
						<ol>
							<li>"보험계약자"가 이용하는 통신업체나 해당업체가 운영하는 통신망 상의 장애나 오작동으로 인한 보험청약 및 증권 출력 등의 업무장애로 인한 문제에 대하여는 "보험사"는 책임지지 아니한다.</li>
							<li>시스템 등의 보수/점검/교체, 시스템의 고장, 통신의 두절, 기타 불가항력적 사유가 발생한 경우에는 사전 통보 없이 서비스의 제공이 일시적으로 중단될 수 있다.</li>
							<li>상기 ②의 사유로 인하여 이용자 또는 제3자가 입은 손해에 대하여는 "보험사"가 책임지지 아니한다.</li>
						</ol>

						<p class="tit">[제 6 조] 보험료의 납입</p>
						<p class="txt">보험료의 납입은 법인이나 개인의 신용카드, 지로, 계좌이체를 통하여 보험계약 체결시 결제함을 원칙으로 한다.<br> 단 "보험계약자"와 보험사"의 사전합의에 의하여 별도의 방식으로 납입할 수 있다. </p>


						<p class="tit">[제 7 조] 보험계약자의 의무 및 책임</p>
						<ol>
							<li>"보험계약자"는 관계 법령, 본 약정서의 규정, 이용안내 및 서비스상에 공지한 주의사항, "보험사"가 통지하는 사항을 준수하여야 한다.</li>
							<li>"보험계약자"는 "보험사"의 사전 동의 없이 서비스를 이용하여 어떠한 영리행위도 할 수 없으며 법에 저촉되는 자료를 배포 또는 게재할 수 없다.</li>
							<li>"보험계약자"는 자신의 ID 및 비밀번호를 유지 관리할 책임이 있으며 자신의 ID 및 비밀번호를 사용하여 발생하는 모든 결과에 대해 전적인 책임이 있다. 또한, 자신의 비밀번호가 자신의 승낙 없이 사용되었을 경우 즉시 "보험사"에 신고하여야 한다.</li>
							<li>"보험계약자"는 이용 신청서의 기재내용에 대해 진실하고 정확하게 고지하여야 하며, 변경사항이 발생하는 경우 이를 즉시 "보험사"에 통보하여야 한다.</li>
							<li>"보험계약자"는 서비스를 이용하여 얻은 정보를 "보험사"의 사전 승낙 없이 복사, 복제, 변경, 번역, 출판, 방송 기타의 방법으로 사용하거나 이를 타인에게 제공할 수 없다.</li>
							<li>"보험계약자"는 서비스를 이용함에 있어 적하보험과 관련 없는 사항이나, 정치적 견해, 유언비어, 광고, 음란물 게재 및 유포 등 사회질서를 해치는 행위를 하여서는 안된다.</li>
							<li>"보험계약자"는 타인의 명예를 훼손하거나 모욕하는 행위와 타인의 지적재산권 등의 권리를 침해하는 행위를 할 수 없다.</li>
							<li>"보험계약자"는 해킹 또는 컴퓨터 바이러스를 유포하는 일, 타인의 의사에 반하여 광고성 정보 등 일정한 내용을 지속적으로 전송하는 행위를 할 수 없다.</li>
							<li>"보험계약자"는 서비스의 운영에 지장을 주거나 줄 우려가 있는 일체의 행위, 기타 관계 법령에 위배되는 일을 할 수 없다.</li>
							<li>"보험계약자"는 "보험사"가 제공한 보험증권 용지를 인터넷 홈페이지의 적하보험 증권출력 이외의 용도로 사용하여 서는 안되며, 본래의 용도 이외로 사용하여 발생하는 모든 민/형사상의 책임을 진다.</li>
							<li>상기 ②의 사유로 인하여 이용자 또는 제3자가 입은 손해에 대하여는 "보험사"가 책임지지 아니한다.</li>
						</ol>


						<p class="tit">[제 8 조] 분쟁의 해결</p>
						<ol>
							<li>"보험사"와 "보험계약자"는 서비스와 관련하여 발생한 분쟁을 원만하게 해결하기 위하여 필요한 모든 노력을 하여야 한다.</li>
							<li>모든 노력에도 불구하고 소송이 제기될 경우, 관할법원은 서울중앙지방법원으로 한다.</li>
						</ol>


						<p class="tit">[제 9 조] 양도금지</p>
						<p class="txt">"보험계약자"는 서비스의 이용권한, 기타 이용계약상 지위를 타인에게 양도, 증여할 수 없으며, 게시물에 대한 저작권을 포함한 모든 권리 및 책임은 이를 게시한 "보험계약자"에게 있다.</p>


						<p class="tit">[제 10 조] 계약해지 및 이용제한</p>
						<ol>
							<li>"보험사"는 "보험계약자"가 법규정 및 약정서의 내용을 위반하였을 경우, 서비스 이용을 즉각 중단할 수 있다.</li>
							<li>"보험사"는 제 ①항에 의해 서비스 이용이 중단된 "보험계약자"가 다시 이용 신청을 하는 경우, 일정기간 그 승낙을 제한할 수 있다.</li>
							<li>"보험계약자"가 서비스 이용 약정을 해지하고자 하는 때에는 "보험계약자" 본인이 서비스 이용 화면에서 또는 전자우편을 통하여 해지신청을 하여야 한다.</li>
							<li>서비스 이용이 해지되는 경우, 기수령한 증권요지 잔여분은 전부 "보험사"에 반납하여야 한다.</li>
						</ol>

						<p class="tit">[제 11 조] 시행일</p>
						<p class="txt">본 약정은 2011년 4월 1일부터 시행한다.</p>
					</div>
				</div>
				<div v-if="joinYn" class="btnWrap"><a href="#" class="btnType sizeR colorBL"><span>취소</span></a><a @click="regiChk()" class="btnType sizeR colorB"><span>동의</span></a>
				</div>
			</div>
		</div>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import util from '@/common/util'
import { sessionUserInfo, load } from '@/common/sessionFactory'
import Header from '@/components/common/Header.vue'
import Footer from '@/components/common/Footer.vue'
const router = useRouter()
const joinYn = ref(false);
const store = useStore();

const regiChk = () => {
	router.push({ name: 'gombrRegi' })
}

onMounted(async () => {
	if(!_.isEmpty(store.state.common.corpNo)){
		joinYn.value = true;
	}
   
})
</script>

<style>

</style>
